import { useProfileContext } from '@/contexts/profile-context';
import { useAuth } from '@/components/auth/AuthProvider';
import { UserTypeSelectionModal } from '@/components/auth/user-type-selection-modal';

export function GlobalUserTypeSelectionDialog() {
  const { user } = useAuth();
  const { 
    shouldShowUserTypeDialog, 
    updateProfileType, 
    isLoading, 
    error 
  } = useProfileContext();

  const handleComplete = async (userType: 'student' | 'teacher', classGrade?: string) => {
    try {
      await updateProfileType(userType, classGrade);
      // Dialog will be automatically hidden by the updateProfileType method
    } catch (error) {
      // Error is handled by the profile context and passed through the error prop
      console.error('Failed to update profile type:', error);
    }
  };

  // Don't render if we don't need to show the dialog or if no user
  if (!shouldShowUserTypeDialog || !user) {
    return null;
  }

  return (
    <UserTypeSelectionModal
      userEmail={user.email}
      userName={
        user.user_metadata?.full_name || 
        user.user_metadata?.name || 
        `${user.user_metadata?.first_name || ''} ${user.user_metadata?.last_name || ''}`.trim() || 
        user.email
      }
      onComplete={handleComplete}
      isLoading={isLoading}
      error={error}
    />
  );
}
